import { createTheme } from '@mui/material/styles';

let customTheme = createTheme({
  palette: {
    primary: {
      main: '#FDD606',
    },
    secondary: {
      main: '#122B87',
    },
  },
  typography: {
    fontFamily: 'Switzer',
  },
});

customTheme = createTheme(customTheme, {
  palette: {
    text: {
      disabled: '#000000',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            background: '#705F00',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#D3D3D3',
            borderRadius: 30,
            '& fieldset': {
              borderRadius: 30,
              border: `1px solid ${customTheme.palette.secondary.main}`,
            },
            '&:hover fieldset': {
              border: `2px solid ${customTheme.palette.secondary.main}`,
            },
            '&.Mui-focused fieldset': {
              borderColor: customTheme.palette.secondary.main,
            },
            '& .MuiChip-label': {
              fontSize: '1rem',
              lineHeight: '1.5rem',
            },
            '&.Mui-disabled': {
              '& fieldset': {
                borderRadius: 30,
                border: '1px solid #aaaaaa',
              },
              '&:hover fieldset': {
                border: '1px solid #aaaaaa',
              },
              '& input': {
                color: '#000000',
                WebkitTextFillColor: '#000000',
              },
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: customTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: customTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: customTheme.palette.secondary.main,
        },
        colorPrimary: {
          '&.Mui-checked': {
            color: customTheme.palette.secondary.main,
          },
        },
        track: {
          '.Mui-checked.Mui-checked + &': {
            opacity: 0.6,
            backgroundColor: customTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          border: '1px solid #8E99C3',
          borderRadius: 9999,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: ' #000000',
          },
          '&.Mui-disabled': {
            color: '#000000',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 9999,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderTop: '1px solid rgba(0, 0, 0, 0.12)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          '&:not(:last-child)': {
            borderBottom: 0,
          },
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          margin: 0,
          width: 'unset',

          '@media (max-width: 768px)': {
            maxHeight: '100%',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: `${customTheme.palette.secondary.main}`,
          '&.Mui-selected': {
            borderRadius: 30,
            backgroundColor: `${customTheme.palette.primary.main}`,
            color: `${customTheme.palette.secondary.main}`,
          },
        },
      },
    },
  },
});

const DateTheme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderRadius: 30,
              border: `1px solid ${customTheme.palette.primary.main}`,
            },
            '&:hover fieldset': {
              border: `2px solid ${customTheme.palette.primary.main}`,
            },
            '&.Mui-disabled': {
              '& fieldset': {
                borderRadius: 30,
                border: '1px solid #aaaaaa',
              },
              '&:hover fieldset': {
                border: '1px solid #aaaaaa',
              },
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFF3B4',
          '&.Mui-disabled input': {
            color: '#000000',
            WebkitTextFillColor: '#000000',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: `${customTheme.palette.primary.main}`,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: ' #000000',
          },
        },
      },
    },
  },
});

const ButtonTheme = createTheme({
  palette: {
    primary: {
      main: '#122B87',
    },
  },
});

const DateLabelBlack = createTheme(DateTheme, {
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: ' #000000',
          '&.Mui-focused': {
            color: ' #000000',
          },
          '&.Mui-disabled': {
            color: '#000000',
          },
        },
      },
    },
  },
});

const SelectThemePrimary = createTheme(customTheme, {
  palette: {
    text: {
      disabled: '#000000',
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFF3B4',
          borderRadius: 30,
          '& fieldset': {
            borderRadius: 30,
            border: `1px solid ${customTheme.palette.primary.main}`,
          },
          '&:hover fieldset': {
            border: `2px solid ${customTheme.palette.primary.main}`,
          },
          '&.Mui-focused fieldset': {
            borderColor: customTheme.palette.primary.main,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: customTheme.palette.primary.main,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: customTheme.palette.primary.main,
          },
          '&.Mui-disabled': {
            '& fieldset': {
              borderRadius: 30,
              border: '1px solid #aaaaaa',
            },
            '&:hover fieldset': {
              border: '1px solid #aaaaaa',
            },
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#000000',
          '&.Mui-focused': {
            color: ' #000000',
          },
          '&.Mui-disabled': {
            color: '#000000',
          },
        },
      },
    },
  },
});

const SelectThemeSecondary = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#D3D3D3',
          borderRadius: 30,
          '& fieldset': {
            borderRadius: 30,
            border: `1px solid ${customTheme.palette.secondary.main}`,
          },
          '&:hover fieldset': {
            border: `2px solid ${customTheme.palette.secondary.main}`,
          },
          '&.Mui-focused fieldset': {
            borderColor: customTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: customTheme.palette.secondary.main,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: customTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: customTheme.palette.secondary.main,
          },
        },
      },
    },
  },
});

export const dateLabelBlack = DateLabelBlack;
export const dateTheme = DateTheme;
export const buttonTheme = ButtonTheme;
export const theme = customTheme;
export const selectThemePrimary = SelectThemePrimary;
export const selectThemeSecondary = SelectThemeSecondary;
